import {Fields, Model} from '@vuex-orm/core';

export default class ItemLevelTax extends Model {

    public static modelName = 'ItemLevelTax';
    public static entity = 'item-level-taxes';

    public orderItemId: number;
    public taxDetails: string;
    public amount: number;
    public quantityRefunded: number;
    public quantity: number;

    public static fields(): Fields {
        return {
            orderItemId: this.number(0),
            taxDetails: this.string(''),
            amount: this.number(0.00),
            quantityRefunded: this.number(0.00),
            quantity: this.number(0.00),
        };
    }
}
